import React from "react";

import { ensureString } from "@intelligems/ig-utils";
import { NewButtonRoot } from "@src/QuantityButtonsView/components/NewButtonRoot";
import { QuantityButtonsWrapper } from "@src/QuantityButtonsView/components/QuantityButtonsWrapper";
import {
  Badge,
  ContentIconWrapper,
  QuantityButtonWidgetVariantWrapper,
  SectionTitle,
  SharedButtonContent,
  SharedColumnLayout,
  SharedRowLayout,
} from "@src/QuantityButtonsView/components/sharedComponents";

import { useQuantityButtonsContext } from "../context/QuantityButtonsContext";

export const QuantityButtonsWidgetImage = () => {
  const { widget } = useQuantityButtonsContext();
  const renderFreeShippingLabelPlaceholder = widget.variables.buttons
    .filter((button) => !button.freeShipping?.hide)
    .some((button) => button.freeShipping?.freeShippingLabel);

  const renderFreeGiftLabelPlaceholder = widget.variables.buttons
    .filter((button) => !button.freeGift?.hide)
    .some((button) => button.freeGift?.freeGiftLabel);

  const renderLabelPlaceholder = widget.variables.buttons.some(
    (button) => button.label
  );

  return (
    <QuantityButtonWidgetVariantWrapper
      buttonVariant={"quantityButtonsWidgetImage"}
    >
      {widget.variables?.sectionTitle && <SectionTitle />}

      <QuantityButtonsWrapper
        renderButton={({ button, selected, index }) => (
          <NewButtonRoot
            key={index}
            button={button}
            selected={selected}
            renderContent={({ button, newTotalPrice, totalComparePrice }) => (
              <div className={"ig-quantity-widget-root-wrapper"}>
                {button.badge && (
                  <Badge className={"ig-quantity-widget-badge"}>
                    {ensureString(button.badge)}
                  </Badge>
                )}
                <SharedButtonContent>
                  <ContentIconWrapper>
                    {button.image ? (
                      <img
                        style={{
                          ...(!selected && {
                            opacity: 0.5,
                          }),
                          width: "50px",
                          height: "auto",
                          borderRadius: "5px",
                        }}
                        src={button.image}
                        alt={`ig-image-button-${index}`}
                        className={"ig-quantity-image"}
                      />
                    ) : (
                      <div
                        className={"ig-quantity-image-placeholder"}
                        style={{
                          width: "50px !important",
                          minWidth: "50px",
                          height: "50px !important",
                          minHeight: "50px",
                          border: `1px dashed #8A8A8A`,
                          borderRadius: "4px",
                          backgroundColor: "#D4D4D4",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          ...(!selected && {
                            opacity: 0.5,
                          }),
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          className="lucide lucide-image-icon lucide-image"
                        >
                          <rect
                            width="18"
                            height="18"
                            x="3"
                            y="3"
                            rx="2"
                            ry="2"
                          />
                          <circle cx="9" cy="9" r="2" />
                          <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" />
                        </svg>
                      </div>
                    )}

                    {widget.styles.appearance.layout === "row" ? (
                      <SharedRowLayout
                        selected={selected}
                        renderFreeGiftLabelPlaceholder={
                          renderFreeGiftLabelPlaceholder
                        }
                        renderFreeShippingLabelPlaceholder={
                          renderFreeShippingLabelPlaceholder
                        }
                        renderLabelPlaceholder={renderLabelPlaceholder}
                        button={button}
                        newTotalPrice={newTotalPrice}
                        totalComparePrice={totalComparePrice}
                      />
                    ) : (
                      <SharedColumnLayout
                        selected={selected}
                        button={button}
                        newTotalPrice={newTotalPrice}
                        totalComparePrice={totalComparePrice}
                      />
                    )}
                  </ContentIconWrapper>
                </SharedButtonContent>
              </div>
            )}
          />
        )}
      />
    </QuantityButtonWidgetVariantWrapper>
  );
};
